export function healthColor(score: number | null): string {
  if (score === null) return 'var(--text-muted)';
  if (score >= 85) return 'var(--success)';
  if (score >= 70) return 'var(--warning)';
  return 'var(--danger)';
}

export function healthTextClass(score: number | null): string {
  if (score === null) return 'text-text-muted';
  if (score >= 85) return 'text-success';
  if (score >= 70) return 'text-warning';
  return 'text-danger';
}

export function barColorClass(score: number): string {
  if (score >= 85) return 'bg-success';
  if (score >= 70) return 'bg-warning';
  return 'bg-danger';
}

export function statusDotClass(status: string): string {
  switch (status) {
    case 'pass': return 'bg-success';
    case 'fail': return 'bg-danger';
    case 'warn': return 'bg-warning';
    default: return 'bg-text-muted';
  }
}

export function maturityStyle(level: string): { bg: string; text: string; border: string } {
  switch (level) {
    case 'gold':
      return { bg: 'rgba(245,158,11,0.12)', text: '#F59E0B', border: 'rgba(245,158,11,0.25)' };
    case 'silver':
      return { bg: 'rgba(148,163,184,0.12)', text: '#94A3B8', border: 'rgba(148,163,184,0.25)' };
    case 'bronze':
      return { bg: 'rgba(217,119,6,0.12)', text: '#D97706', border: 'rgba(217,119,6,0.25)' };
    default:
      return { bg: 'var(--elevated)', text: 'var(--text-muted)', border: 'var(--border)' };
  }
}

export function relativeTime(timestamp: string): string {
  const now = Date.now();
  const then = new Date(timestamp).getTime();
  const diffMs = now - then;
  const diffMin = Math.floor(diffMs / 60_000);
  const diffHr = Math.floor(diffMs / 3_600_000);
  const diffDay = Math.floor(diffMs / 86_400_000);

  if (diffMin < 1) return 'Just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  if (diffHr < 24) return `${diffHr}h ago`;
  if (diffDay === 1) return 'Yesterday';
  if (diffDay < 30) return `${diffDay}d ago`;
  return new Date(timestamp).toLocaleDateString();
}

export function formatDuration(ms: number | null): string {
  if (ms === null) return '—';
  if (ms < 1000) return `${ms}ms`;
  const s = Math.floor(ms / 1000);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  const remaining = s % 60;
  return `${m}m ${remaining}s`;
}

export function formatNumber(n: number): string {
  return n.toLocaleString();
}
